import { EventDto } from '@diritto/common/event/dtos/event.dto';
import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { EventBadge } from 'app-components/contents/EventBadge';
import { Link } from 'ui-components/common/Link';

export const ContentDetailEventItem = ({ event }: { event: EventDto }) => (
  <Link href={`/events/${event.id}`}>
    <StyledContainer>
      <EventBadge />
      <p>{event.title}</p>
    </StyledContainer>
  </Link>
);

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  width: 100%;
  border-bottom: 1px solid ${Color.Gray200};
  & > p {
    ${Typography.XXSmall};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    word-break: break-all;
    word-wrap: anywhere;
    margin-left: 8px;
  }
`;
